import { MedicalHistory } from "@elixir/types";
import { GET_PARCHI_HOST } from "../constants/env";
import fetch from "../fetch-client";
import { ParchiGenericApiResponse } from "../types/parchi";

export default async function getPatientMedicalHistory({
  doctorOid,
  patientOid,
}: {
  doctorOid: string;
  patientOid: string;
}): Promise<ParchiGenericApiResponse<MedicalHistory>> {
  try {
    const PARCHI_HOST = GET_PARCHI_HOST();
    let endpoint = `${PARCHI_HOST}/app/get/patientmedicalhistory/?docid=${doctorOid}&pid=${patientOid}&flavour=dw`;
    const res = await fetch(endpoint, {
      method: "GET",
      redirect: "follow",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    });

    return res.json();
  } catch (e) {
    return { status: "error", success: false };
  }
}
